import {RootState} from '../reducers';

export const authSelector = (state: RootState) => state.auth;
